import { all } from 'redux-saga/effects'

import { statisticsSaga } from './statistics/sagas'

export function* userSaga() {
  yield all([statisticsSaga()])
}
